/* eslint-disable max-len */
import React from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const RegenerateIcon: React.FC<IconProps> = (props) => {
  return (
    <BaseIcon {...props}>
      <path d="M7 16C7 11.0314 11.0368 7 16.0208 7C19.1478 7 21.9039 8.58713 23.5228 11H21C20.4477 11 20 11.4477 20 12C20 12.5523 20.4477 13 21 13H26H27V12V7C27 6.44772 26.5523 6 26 6C25.4477 6 25 6.44772 25 7V9.6208C23.0024 6.82463 19.7254 5 16.0208 5C9.93615 5 5 9.92291 5 16C5 16.5523 5.44772 17 6 17C6.55228 17 7 16.5523 7 16ZM6.07155 26.0348C5.51928 26.039 5.06819 25.5947 5.06402 25.0424L5.02624 20.0425L5.01869 19.0426L6.01866 19.035L11.0185 18.9972C11.5708 18.9931 12.0219 19.4374 12.0261 19.9896C12.0302 20.5419 11.5859 20.993 11.0337 20.9972L8.50775 21.0163C10.1416 23.4205 12.9085 24.9915 16.0367 24.9718C21.0206 24.9404 25.0319 20.8837 25.0007 15.9152C24.9972 15.3629 25.4421 14.9124 25.9943 14.9089C26.5466 14.9054 26.9971 15.3503 27.0006 15.9026C27.0389 21.9796 22.1338 26.9335 16.0493 26.9718C12.3466 26.9951 9.05961 25.1929 7.0442 22.4118L7.06396 25.0273C7.06814 25.5796 6.62382 26.0307 6.07155 26.0348Z" />
    </BaseIcon>
  );
};
